import { render, staticRenderFns } from "./CompanyServices.vue?vue&type=template&id=a522ca4e&scoped=true"
import script from "./CompanyServices.vue?vue&type=script&lang=js"
export * from "./CompanyServices.vue?vue&type=script&lang=js"
import style0 from "./CompanyServices.vue?vue&type=style&index=0&id=a522ca4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a522ca4e",
  null
  
)

export default component.exports